const doc = [({"ko":({"adminConstantMessageType":({"button":"버튼", "carousels":"회전 목마", "externalImage":"외부 이미지", "image":"이미지", "quickReply":"빠른 응답", "text":"텍스트"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;